import { LockboxStatus } from '@/modules/employer/components/Lockbox/lockbox.types';
import { storeCreator } from '@/utils/store/store.utils';

interface State {
  highlightStatus?: LockboxStatus;
  setHighlightStatus: (value?: LockboxStatus) => void;
  reset: () => void;
}

const useHighlightLockboxStatusStore = storeCreator<State>((set) => ({
  highlightStatus: undefined,

  setHighlightStatus: (value?: LockboxStatus) => set(() => ({
    highlightStatus: value,
  })),

  reset: () => set(() => ({
    highlightStatus: undefined,
  })),
}));

export default useHighlightLockboxStatusStore;
